module.exports = __webpack_public_path__ + "static/img/blog-7.6e3c13f7.jpg";